import {FinancialApplicationSource} from "../types/financial_application";

const cbkAccountBySource: Record<FinancialApplicationSource, string> = {
    [FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR]: "rp_installment_calculator",
    [FinancialApplicationSource.RP_CREDITWORTHINESS_CALCULATOR]: "rp_creditworthiness_calculator"
};

export const getCbkAccountHeaders = (source: FinancialApplicationSource) => ({"X-CBK-Account": cbkAccountBySource[source]});
import {FinancialApplicationSource} from "../types/financial_application";

const cbkAccountBySource: Record<FinancialApplicationSource, string> = {
    [FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR]: "rp_installment_calculator",
    [FinancialApplicationSource.RP_CREDITWORTHINESS_CALCULATOR]: "rp_creditworthiness_calculator"
};

export const getCbkAccountHeaders = (source: FinancialApplicationSource) => ({"X-CBK-Account": cbkAccountBySource[source]});
